import Repository from './Repository';

class UserRepository extends Repository {
	/**
	 * Refreshes & returns the currently logged in user.
	 *
	 * @returns {Promise<object>} The user object
	 */
	async getCurrent () {
		return this.getWithToken('/user');
	}

	all () {
		return this.getWithToken('/user/all');
	}

	create (request) {
		return this.postWithToken('/users', request);
	}

	update (userId, request) {
		return this.putWithToken(`/users/${userId}`, request);
	}

	activate (userId) {
		return this.patchWithToken(`/users/${userId}/activate`);
	}

	deactivate (userId) {
		return this.patchWithToken(`/users/${userId}/deactivate`);
	}

	updatePassword (form) {
		return this.patchWithToken('/users/password', form);
	}

	updateProfile (form) {
		return this.patchWithToken('/users/profile', form);
	}

	removeUser (userId) {
		return this.deleteWithToken(`/users/${userId}`);
	}

	updateRoles (form) {
		return this.putWithToken(`/users/${form.id}/assign-roles`, form);
	}
}

export default new UserRepository();
